import { getToken } from "./localStorage";
import { ToqioAxiosInstance, ToqioRequestConfig } from "./types";
import { getMakertplaceKey } from "./workflows";
import { BASE_URL } from '../config/api.config';

export const setWorkflowsInterceptor = () => {
  /**
     * Fetch interceptor for presigned urls on WFs custom component File uploader and downloader
     * 
     * We need to intercept the WFs presigned component url, so we can add:
     * - the API_URL (according to environment)
     * - the token of the user
     */
  const { fetch: originalFetch } = window;
  window.fetch = async (...args) => {
    const presignedUrlPath = 'presigned-url';
    const [url, config] = args;

    let completeUrl = url;

    // intercept only the presigned urls
    if ((url as string).includes(presignedUrlPath)) {
      // add the correct url according to the environment api url
      // do not add / after iam, as the url already starts with /
      completeUrl = `${BASE_URL}/iam${url}`;

      // add corresponding token to the headers
      const token = getToken();

      if (config) {
        (config as ToqioRequestConfig).withCredentials = true;
        config.headers = {
          ...config.headers,
          ...(token ? { Authorization: `Bearer ${token}` } : {}), // Add Authorization header if token exists
        };
      }
    }

    // finish the fetch after intercepted 
    return originalFetch(completeUrl, config);
  };

  const browserLanguage = navigator.language || (navigator as any).userLanguage || 'en-GB';

  /**
   * HTTP interceptor for flowable endpoints
   * 
   * We need to intercept the flowable requests, so we can add:
   * - token of the user
   * - language
   * - marketplace key
   */
  window.flowable.httpClientCustomConfiguration = (io: ToqioAxiosInstance): void => {
    io.interceptors.request.use((config: ToqioRequestConfig): ToqioRequestConfig => {
      const marketplaceKey = getMakertplaceKey(window.location.pathname);
      const token = getToken();

      config.withCredentials = true;
      config.headers = {
        ...config.headers,
        'Accept-Language': browserLanguage, 
        'Authorization': `Bearer ${token}`,
        'MarketplaceKey': marketplaceKey,
      };
      return config;
    });
  }
}